import { Card } from 'antd';
import React from 'react';
import TaobaoOrders from './TaobaoOrders';
import TianmaoOrders from './TianmaoOrders';
import JingdongOrders from './JingdongOrders';

class CustomerShopOrders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: null
    };
  }

  componentDidMount() {
    let tab = localStorage.getItem('customer_shop_orders_default_tab');
    if (tab === null) {
      tab = 'taobao';
      localStorage.setItem('customer_shop_orders_default_tab', tab);
    }
    this.setState({tab: tab});
  }

  handleTabChange = key => {
    localStorage.setItem('customer_shop_orders_default_tab', key);
    this.setState({tab: key})
  }

  render() {
    const tabs = [
      {
        key: 'taobao',
        tab: '淘宝订单'
      },
      // {
      //   key: 'pinduoduo',
      //   tab: '拼多多订单'
      // },
      {
        key: 'tianmao',
        tab: '天猫订单'
      },
      {
        key: 'jingdong',
        tab: '京东订单'
      }
    ];

    const contentList = {
      taobao: <TaobaoOrders/>,
      pinduoduo: '待开发',
      tianmao: <TianmaoOrders/>,
      jingdong: <JingdongOrders/>
    };

    return (
      <Card activeTabKey={this.state.tab} tabList={tabs} onTabChange={this.handleTabChange}>
        {contentList[this.state.tab]}
      </Card>
    );
  }
}

export default CustomerShopOrders;